<template>
  <a :href="computedLink" target="_blank" class="text-white">
    <div class="p-4 d-block bg-danger">
      Para habilitar essa função ative o Plano Pro.<br />CLIQUE AQUI para saber como ativar
    </div>
  </a>
</template>

<script>
export default {
  props: {
    hash: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      appLinkSuporte: '/'
    };
  },
  computed: {
    computedLink() {
      return this.hash ? `${this.appLinkSuporte}${this.hash}` : this.appLinkSuporte;
    }
  }
};
</script>
